import { render, staticRenderFns } from "./datashareCallData.vue?vue&type=template&id=63f0ccd7"
import script from "./datashareCallData.vue?vue&type=script&lang=js"
export * from "./datashareCallData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports